import type { ChartDataPoint, MetricType } from './types';
import { Paths } from '@/store/constants';
import { apiInvoke } from '@/store/helpers/load';
import type { APIParams } from '@/store/helpers/types';
import type { ApiResponse } from '@/shared/types/api';

export async function loadMetrics({
  api,
  auth,
  type,
  campusId,
}: {
  type: MetricType;
  campusId?: string;
} & APIParams): Promise<ChartDataPoint[]> {
  const query = new URLSearchParams();
  query.set('type', type);
  if (campusId) {
    query.set('campusId', campusId);
  }

  const path = `${Paths.metrics}?${query.toString()}`;
  const response = await apiInvoke<ApiResponse<ChartDataPoint[]>>(
    api,
    path,
    auth,
    {
      method: 'GET',
    },
  );

  return response.data;
}
